import useAuth from "app/hooks/useAuth";
import { flat } from "app/utils/utils";
import { Navigate, useLocation } from "react-router-dom";
import AllPages from "../routes";

const Permission = (pathname, user, routes) => {
  var UserRoles = [];
  for (let i = 0; i < user?.roles?.length; i++) {
    UserRoles.push(user?.roles[i]?.role?.role);
  }
  // const rolesPerUser = UserRoles.join(",")
  // console.log(UserRoles)
  // if (!user) {
  //   return false;
  // }
  // console.log(UserRoles)
  const matched = routes.find((r) => r.path === pathname);
  // console.log(matched.auth)
  const authenticated =
    matched && matched.auth && matched.auth.length
      ? matched.auth.some((ai) => UserRoles.includes(ai))
      : true;
  // console.log(matched, user);
  // console.log(authenticated)
  return authenticated;
};

const AuthGuard = ({ children }) => {
  let { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();

  const routes = flat(AllPages);

  const hasPermission = Permission(pathname, user, routes);
  let authenticated = isAuthenticated && hasPermission;

  // // IF YOU NEED ROLE BASED AUTHENTICATION,
  // // UNCOMMENT ABOVE LINES
  // // AND COMMENT OUT BELOW authenticated VARIABLE

  // let authenticated = isAuthenticated;
  // if (!hasPermission) {
  //   Swal.fire({
  //     title: "ACCESS DENIED!",
  //     icon: "error",
  //     timer: 2000,
  //     showCancelButton: false,
  //     showConfirmButton: false
  //   });
  // }
  if (user === null) {
    Navigate(0);
  }
  if (authenticated) return <>{children}</>;
  else {
    return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
  }
};

export default AuthGuard;
